import { createContext } from 'react'

export interface ZipCodeContextState {
  zipCode?: string
  updateZipCode: (val: string | undefined) => Promise<boolean>
  isZipcodeModalOpen: boolean
  openZipcodeModal: (val: boolean) => void
}

const ZipCodeContext = createContext<ZipCodeContextState>({
  updateZipCode: () => Promise.resolve(true),
  isZipcodeModalOpen: false,
  openZipcodeModal: () => undefined,
})

// @i18n-ignore
const ZIP_CODE_CONTEXT_DISPLAY_NAME = 'Zip Code Context'
ZipCodeContext.displayName = ZIP_CODE_CONTEXT_DISPLAY_NAME

export default ZipCodeContext
